import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../services/authService';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

/**
 * OAuth Callback 페이지
 * 소셜 로그인 후 토큰을 받아서 저장하고 대시보드로 이동
 */
function OAuthCallback() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { handleLogin } = useAuth();
    const { showToast } = useToast();

    useEffect(() => {
        const token = searchParams.get('token');
        const error = searchParams.get('error');

        if (error) {
            // 에러 발생 시 로그인 페이지로 리다이렉트
            showToast({ type: 'error', message: `로그인 실패: ${error}` });
            navigate('/');
            return;
        }

        if (token) {
            // 토큰을 임시 저장하고 사용자 정보 조회
            localStorage.setItem('token', token);

            // 사용자 정보 조회 후 handleLogin으로 처리
            authService.getMe()
                .then(data => {
                    handleLogin(data.user, token);
                })
                .catch(err => {
                    console.error('사용자 정보 조회 실패:', err);
                    localStorage.removeItem('token');
                    showToast({ type: 'error', message: '로그인 처리 중 오류가 발생했습니다.' });
                    navigate('/');
                });
        } else {
            // 토큰도 에러도 없으면 홈으로
            navigate('/');
        }
    }, [searchParams, navigate, handleLogin, showToast]);

    return (
        <div className="auth-page">
            <div className="auth-card" style={{ textAlign: 'center' }}>
                <div className="loading-spinner" style={{ margin: '0 auto var(--spacing-16)' }}></div>
                <p className="auth-subtitle">
                    로그인 처리 중...
                </p>
            </div>
        </div>
    );
}

export default OAuthCallback;
